import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {injectIntl} from 'react-intl';
import {InputFieldWithValidation} from '../../../common/InputFieldWithValidation';
import {
    FORM_FIELD_CAR_MODEL,
    FORM_FIELD_ENGINE_SERIAL_NUMBER,
    FORM_FIELD_ENGINE_TYPE,
    FORM_FIELD_GEARBOX_SERIAL_NUMBER,
    FORM_FIELD_GEARBOX_TYPE,
    FORM_FIELD_MANUFACTURE_DATE,
    FORM_FIELD_REGISTRATION_NO,
    FORM_FIELD_VIN,
    FORM_LABEL_CAR_MODEL,
    FORM_LABEL_ENGINE_SERIAL_NUMBER,
    FORM_LABEL_ENGINE_TYPE,
    FORM_LABEL_GEARBOX_SERIAL_NUMBER,
    FORM_LABEL_GEARBOX_TYPE,
    FORM_LABEL_MANUFACTURE_DATE,
    FORM_LABEL_REGISTRATION_NO,
    FORM_LABEL_VIN
} from '../../../../constants/formConstants';
import {Field} from 'redux-form';
import BorderRadius from '../../../common/styled/BorderRadius';
import DatePickerComponent from '../../../common/datePicker/DatePickerComponent';
import moment from 'moment';
import fulltextSearchMessages from '../../../../intl/afterSales/fulltextSearchMessages';

const VehicleDetailSection = ({domain, intl}, ) => {

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...fulltextSearchMessages.VEHICLE_DETAIL_SECTION}/>
            </h3>
            <BorderRadius size={5} className="border border-secondary p-4 bg-white">
                <div className="form-row">
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_VIN]}
                                                  field={FORM_FIELD_VIN}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <Field component={DatePickerComponent}
                               selectsEnd
                               isClearable
                               label={fulltextSearchMessages[FORM_LABEL_MANUFACTURE_DATE]}
                               name={FORM_FIELD_MANUFACTURE_DATE}
                               parse={(e) => e ? moment(e).format('YYYY-MM-DD') : null}/>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_CAR_MODEL]}
                                                  field={FORM_FIELD_CAR_MODEL}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_REGISTRATION_NO]}
                                                  field={FORM_FIELD_REGISTRATION_NO}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_ENGINE_TYPE]}
                                                  field={FORM_FIELD_ENGINE_TYPE}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_ENGINE_SERIAL_NUMBER]}
                                                  field={FORM_FIELD_ENGINE_SERIAL_NUMBER}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_GEARBOX_TYPE]}
                                                  field={FORM_FIELD_GEARBOX_TYPE}
                                                  isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation label={fulltextSearchMessages[FORM_LABEL_GEARBOX_SERIAL_NUMBER]}
                                                  field={FORM_FIELD_GEARBOX_SERIAL_NUMBER}
                                                  isSmall
                        />
                    </div>
                </div>
            </BorderRadius>
        </>
    )
};

const mapStateToProps = (state) => ({
    roles: state.profile.userDetail.roles,
});

const mapDispatchToProps = (dispatch, props) => ({
});


export default  connect(mapStateToProps, mapDispatchToProps)(injectIntl(VehicleDetailSection));
